import { UserSetting } from '../types';

const parseSettings = (
  setting: UserSetting<string>,
  format: 'json' | 'text',
): object | string | null => {
  if (format === 'json') {
    try {
      return JSON.parse(setting.value);
    } catch (e) {
      return null;
    }
  }

  return setting.value;
};

export default parseSettings;
